import { useMaintenanceAccidentsStore, useQualityComplaintsStore, useUserStore } from '@/stores'
import { createPrefetchGuard } from '@/utils/routerGuards'
import { useUsersService } from '@/views/Administration/Users/services/usersService'
import Maintenance from '@/views/Maintenance/Index.vue'

export default [
    {
        path: '/maintenance',
        name: 'maintenance',
        component: Maintenance,
        meta: {
            title: 'maintenance.pageTitle',
            menuRendered: true,
            menuTitle: 'maintenance.menuTitle',
            icon: 'mdi-alert',
            permission: 'accidents'
        },
        redirect: { name: 'accidents' },
        children: [
            {
                path: '/maintenance/accidents',
                name: 'accidents',
                component: () => import('@/views/Maintenance/Accidents/Index.vue'),
                beforeEnter: createPrefetchGuard({
                    getId: () => 'accidents',
                    fetch: async () => {
                        const userStore = useUserStore()
                        const usersService = useUsersService()
                        const maintenanceAccidentsStore = useMaintenanceAccidentsStore()
                        const qualityComplaintsStore = useQualityComplaintsStore()

                        const prefetchUserProfile = async () => {
                            if (!userStore.userId) return
                            if (String(userStore.user?.id) === String(userStore.userId)) return

                            const response = await usersService.fetchUserById(userStore.userId)
                            userStore.getUser(response.data)
                        }

                        await Promise.all([
                            maintenanceAccidentsStore.fetchAccidentTypes(),
                            maintenanceAccidentsStore.fetchMachinesBasicData(),
                            maintenanceAccidentsStore.fetchSoftwareTypes(),
                            maintenanceAccidentsStore.fetchAccidentStatuses(),
                            maintenanceAccidentsStore.fetchAccidentUserDepartments(),
                            maintenanceAccidentsStore.fetchAccidentDepartments(),
                            maintenanceAccidentsStore.fetchCostCenterNumbers(),
                            qualityComplaintsStore.fetchProductionDepartments(),
                            prefetchUserProfile()
                        ])
                    },
                    onError: () => true
                }),
                meta: {
                    title: 'maintenance.accidents.list.pageTitle',
                    requiresAuth: true,
                    permission: 'accidents'
                }
            },
            {
                path: '/maintenance/accidents/dashboard',
                name: 'accidentsDashboard',
                component: () => import('@/views/Maintenance/Accidents/Dashboard/Index.vue'),
                meta: {
                    title: 'maintenance.accidents.dashboard.pageTitle',
                    requiresAuth: true,
                    permission: 'accident_dashboard_read'
                }
            },
            {
                path: '/maintenance/accidents/edit/:id',
                name: 'maintenanceAccidentsEdit',
                component: () => import('@/views/Maintenance/Accidents/Accident.vue'),
                beforeEnter: createPrefetchGuard({
                    getId: (to) => to.params?.id,
                    fetch: async (id) => {
                        const userStore = useUserStore()
                        const usersService = useUsersService()
                        const maintenanceAccidentsStore = useMaintenanceAccidentsStore()

                        const prefetchUserProfile = async () => {
                            if (!userStore.userId) return
                            if (String(userStore.user?.id) === String(userStore.userId)) return

                            const response = await usersService.fetchUserById(userStore.userId)
                            userStore.getUser(response.data)
                        }

                        await Promise.all([maintenanceAccidentsStore.fetchAccident(id), prefetchUserProfile()])
                    },
                    onMissingId: () => ({ name: 'accidents' }),
                    onError: () => ({ name: 'accidents' })
                }),
                meta: {
                    title: 'maintenance.accidents.details.pageTitle',
                    requiresAuth: true,
                    permission: 'accidents'
                }
            }
        ]
    }
]
